export const MODAL_LINK_PREFIX = '/modalComponent/isOpen/';

export function isModalPath(path: string): boolean {
    return path.includes(MODAL_LINK_PREFIX);
}
